export default __webpack_public_path__ + "static/media/SWT0880.34I-19623_-14723_0.083ac4e5.jpg";